import { 
  CROPPER_META_KEY, 
  // additional_ajax_data 
} from "../../var";
import { useProduct } from "../store/product";
import { useCropperStore } from "../store/cropper/cropper-store";
import useTotals from "./use-totals";

// const getAdditionalAjaxData = (action) => {
//   if (additional_ajax_data[action]) {
//     return additional_ajax_data[action];
//   }
// };

export const useCheckoutData = () => {
  const cropper = useCropperStore(s => s.getCropper());
  const product = useProduct(s => s.product);
  return {
    debug: (action, _wpnonce, data) => ({
      action,
      product_sku: product.sku,
      _wpnonce,
      data
    }),
    get: (action, _wpnonce) => ({
      /** @var action wp ajax action */
      action,
      /** @var string _wpnonce wordpress nonce */
      _wpnonce,
      /** @var product_id product ID */
      product_id: product.id,
      [CROPPER_META_KEY]: {
        ...cropper._getCustomPrintData(),
        p_id: product.id,
        edited: true,
      }
    })
  };
}